/* istanbul ignore file */
import React from 'react';
import { WysiwygInput, WysiwygInputProps } from 'framework/form';
import {
  WysiwygInputPasteArtifactDecorator,
  WysiwygInputPasteArtifactDecoratorProps,
} from 'domain/shared/artifact/input';
import { ARTIFACT_ID } from 'domain/shared/artifact';

const TimelineFeedbackWysiwygInput = ({
  artifactsSource,
  ...props
}: WysiwygInputProps & Omit<WysiwygInputPasteArtifactDecoratorProps, 'children'>) => {
  return (
    <WysiwygInputPasteArtifactDecorator
      artifactsSource={artifactsSource}
      artifactTypeId={ARTIFACT_ID.FEEDBACK_ATTACHMENT}
    >
      <WysiwygInput {...props} />
    </WysiwygInputPasteArtifactDecorator>
  );
};

export default TimelineFeedbackWysiwygInput;
